export default __webpack_public_path__ + "fbf25186f14fec9e0e19f076dce39bbd.jpg";